import MainLayout from '../components/MainLayout/MainLayout'
import { PrivacyPolicyResponse } from '@components/Policy/types'
import { fetchPagePolicy } from '@components/Policy/functions'
import dateFormat from 'dateformat'
import { MDXRemote } from 'next-mdx-remote'

export const getServerSideProps = async (): Promise<{
  props: { data: PrivacyPolicyResponse }
}> => {
  const data = await fetchPagePolicy('terms-and-condition')
  return { props: { data } }
}

export default function Terms(props: { data: PrivacyPolicyResponse }) {
  return (
    <MainLayout title="Terms and Conditions">
      <div className="main-container overflow-x-hidden px-4 md:px-24">
        <div className="text-center md:text-left mt-16 md:mt-20 mb-8">
          <h1 className="font-bold text-bidfta-gray-dark text-27 md:text-35">
            {props.data.data.attributes.title}
          </h1>
        </div>
        <div className="mb-8">
          <p>
            Last modified:{' '}
            {dateFormat(props.data.data.attributes.updatedAt, 'longDate')}
          </p>
        </div>
        <div className={'prose mb-16'} style={{ maxWidth: '100%' }}>
          <MDXRemote {...props.data.data.attributes.body} />
        </div>
      </div>
    </MainLayout>
  )
}
